// Auto generated file, do not manually modify!
// com.hotpads.rewardsapi.client.enums.RewardsApiUserStatus

export enum RewardsApiUserStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  UNENROLLED = 'UNENROLLED',
}

export const RewardsApiUserStatus_values = [
  RewardsApiUserStatus.ACTIVE,
  RewardsApiUserStatus.CANCELED,
  RewardsApiUserStatus.UNENROLLED,
] as const;
